// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"68946b05","213":"6e68a788","245":"28751157","950":"82fbf168"}[chunkId] + ".chunk.js";
};